import { Box, Divider, Grid } from '@mui/material'
import ProfileSectionHeader from 'components/common/ProfileSectionHeader/ProfileSectionHeader';
import useGlobalStyles from 'styles/globalStyles'
import AddPositionButton from '../AddPositionButton/AddPositionButton';
import { colors } from 'styles/colors';
import { useProfileContext } from 'context/ProfileContext';
import PositionItem from '../PositionItem/PositionItem';
import PositionItemSkeleton from '../PositionItemSkeleton/PositionItemSkeleton';
import ExperienceIcon from 'icons/ExperienceIcon';
import { hexWithOpacity } from 'common/utils';
import CustomText from 'components/common/CustomText/CustomText';

export default function Experiences() {
  const globalStyles = useGlobalStyles();
  const { experiences, isLoading, isFetching } = useProfileContext();
  const showSkeleton = isLoading && experiences.length === 0;

  return (
    <Box
      className={globalStyles.sectionContainer}
      sx={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box px={2}>
        <ProfileSectionHeader
          title={'Experience'}
          icon={<ExperienceIcon size={20} color={colors.primary} />}
          buttons={[
            <AddPositionButton key='experience' entity={'experience'} />
          ]}
        />
      </Box>

      <Divider />

      <Grid
        container
        spacing={1.5}
        p={2}
        sx={{
          flexGrow: showSkeleton || experiences.length > 0 ? 0 : 1,
          display: 'flex',
        }}
      >
        {showSkeleton ? (
          Array.from({ length: 12 }).map((_, index) => (
            <Grid
              key={index}
              size={{
                xs: 12,
                lg: 6,
                xl: 4,
              }}
            >
              <PositionItemSkeleton />
            </Grid>
          ))
        ) : experiences?.length === 0 ? (
          <Grid
            size={{ xs: 12 }}
            sx={{
              display: 'flex',
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              flex={1}
              textAlign="center"
              gap={2}
            >
              <Box height={100}>
                <ExperienceIcon
                  size={100}
                  color={hexWithOpacity(colors.secondary, 0.5)}
                />
              </Box>
              <CustomText
                text='No experience added yet'
                color={colors.secondary}
              />
            </Box>
          </Grid>
        ) : (
          experiences.map((item: any) => (
            <Grid
              key={item.id}
              size={{
                xs: 12,
                lg: 6,
                xl: 4,
              }}
            >
              <PositionItem item={item} />
            </Grid>
          ))
        )}
      </Grid>

    </Box>
  )
}
